import { render } from "./DebtDetail.vue?vue&type=template&id=bbafbea4&scoped=true"
import script from "./DebtDetail.vue?vue&type=script&lang=js"
export * from "./DebtDetail.vue?vue&type=script&lang=js"

import "./DebtDetail.vue?vue&type=style&index=0&id=bbafbea4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbafbea4"]])

export default __exports__